import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedCrossFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M20.556 3.167C19.606 1.346 17.042 1 12 1s-7.606.346-8.556 2.167c.762-.294 1.592-.492 2.467-.63C7.59 2.274 9.624 2.2 12 2.2s4.41.073 6.088.338c.875.137 1.706.335 2.468.629"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.207 13.5C.226 5.188 2.557 4 12 4c9.393 0 11.749 1.175 10.809 9.366a6.8 6.8 0 0 0-9.32 9.62q-.705.015-1.489.014c-8.463 0-9.812-1.187-10.793-9.5M5 9.1v1.8h14V9.1zm.5 5.3h7v-1.8h-7z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10m-2.758-6.485L17.727 19l-1.485 1.485 1.273 1.273L19 20.273l1.485 1.485 1.273-1.273L20.273 19l1.485-1.485-1.273-1.273L19 17.727l-1.485-1.485z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
CardLinesStackedCrossFilledSize24Glyph.displayName = 'CardLinesStackedCrossFilledSize24Glyph';
